"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

require("moment/locale/nb");

require("moment/locale/nn");

require("moment/locale/sv");

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class FormatDimension extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderCompare", () => {
      const _this$props = this.props,
            name = _this$props.name,
            value = _this$props.value;

      _moment.default.locale('nb');

      let v1, v2;
      const isSameYear = (0, _moment.default)(value[0]).isSame(value[1], 'year');
      const isSameMonth = (0, _moment.default)(value[0]).isSame(value[1], 'month');
      const isSameDay = (0, _moment.default)(value[0]).isSame(value[1], 'day');

      if (name == 'ga:nthYear') {
        v1 = (0, _moment.default)(value[0]).format('YYYY');
        v2 = (0, _moment.default)(value[1]).format('YYYY');
      }

      if (name == 'ga:nthMonth') {
        v1 = (0, _moment.default)(value[0]).format('MMMM YYYY');
        v2 = (0, _moment.default)(value[1]).format('MMMM YYYY');

        if (isSameYear) {
          v1 = (0, _moment.default)(value[0]).format('MMMM');
          v2 = (0, _moment.default)(value[1]).format('MMMM');
        }
      }

      if (name == 'ga:nthWeek') {
        v1 = (0, _moment.default)(value[0]).format('Wo YYYY');
        v2 = (0, _moment.default)(value[1]).format('Wo YYYY');
      }

      if (name == 'ga:nthDay') {
        v1 = (0, _moment.default)(value[0]).format('ll');
        v2 = (0, _moment.default)(value[1]).format('ll');

        if (isSameYear) {
          v1 = v1.replace((0, _moment.default)(value[0]).format('YYYY'), '');
          v2 = v2.replace((0, _moment.default)(value[0]).format('YYYY'), '');
        }

        if (isSameMonth) {
          v1 = v1.replace((0, _moment.default)(value[0]).format('MMM'), '');
        }
      }

      if (name == 'ga:nthHour') {
        v1 = (0, _moment.default)(value[0]).format('lll');
        v2 = (0, _moment.default)(value[1]).format('lll');

        if (isSameYear) {
          v1 = v1.replace((0, _moment.default)(value[0]).format('YYYY'), '');
          v2 = v2.replace((0, _moment.default)(value[0]).format('YYYY'), '');
        }

        if (isSameDay) {
          v2 = (0, _moment.default)(value[1]).format('HH:mm');
        }
      }

      if (name == 'ga:nthMinute') {
        v1 = (0, _moment.default)(value[0]).format('HH:mm');
        v2 = (0, _moment.default)(value[1]).format('HH:mm');
      }

      return v1 + " vs. " + v2;
    });
  }

  render() {
    const _this$props2 = this.props,
          name = _this$props2.name,
          value = _this$props2.value;

    if (Array.isArray(value) && value.length === 2) {
      return this.renderCompare();
    }

    if (name == 'ga:nthYear') {
      return (0, _moment.default)(value).format('YYYY');
    }

    if (name == 'ga:nthMonth') {
      return (0, _moment.default)(value).format('MMMM');
    }

    if (name == 'ga:nthWeek') {
      const w1 = (0, _moment.default)(value).startOf('week').format('DD. MMM');
      const w2 = (0, _moment.default)(value).endOf("week").format('DD. MMM');
      return w1 + "–" + w2; //            return moment(value).format('Wo YYYY')
      //            return moment(value).format('Wo YYYY')
    }

    if (name == 'ga:nthDay') {
      return (0, _moment.default)(value).format('LL');
    }

    if (name == 'ga:nthHour') {
      return (0, _moment.default)(value).format('llll');
    }

    if (name == 'ga:nthMinute') {
      return (0, _moment.default)(value).format('HH:mm');
    }

    return value;
  }

}

_defineProperty(FormatDimension, "contextTypes", {
  intl: _propTypes.default.object
});

FormatDimension.propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.string])
} : {};
var _default = FormatDimension;
exports.default = _default;
module.exports = exports.default;